import { render, staticRenderFns } from "./OpenIndicator.vue?vue&type=template&id=7182bcd4&"
import script from "./OpenIndicator.vue?vue&type=script&lang=ts&"
export * from "./OpenIndicator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports